var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('AMCViewer',{attrs:{"activity-state":_vm.activityState},on:{"update:activityState":function($event){return _vm.$emit('update:activityState', $event)}},model:{value:(_vm.value.body.contents),callback:function ($$v) {_vm.$set(_vm.value.body, "contents", $$v)},expression:"value.body.contents"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }